import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { aceiteMedicoDaAutorizacaoParcialSeAplica } from '@/utils/common'

@Component
export class AceiteMedicoAutorizacaoParcialMixin extends Vue {
  aceiteMedicoSeAplica(situacao: { key: string } | null) {
    return aceiteMedicoDaAutorizacaoParcialSeAplica(situacao && situacao.key)
  }
}

export default AceiteMedicoAutorizacaoParcialMixin
